/** 홈 「코담 디자인 포트폴리오」슬라이더 — 통합 디자인 갤러리 연도순 대표作 */

import {
    codamDesignPortfolioItems,
    codamDesignPortfolioItemHref,
    CODAM_DESIGN_PORTFOLIO_PATH,
} from '../views/inner-pages/design/codamDesignPortfolioData'

export const CODAM_DESIGN_HOME_PATH = '/codam-design'

const TAG_MODIFIERS = ['', 'tag-02', 'tag-03', 'tag-04', 'tag-02', 'tag-03', 'tag-04', '']

/** @type {number} */
export const HOME_DESIGN_SLIDER_LIMIT = 8

/**
 * @type {Array<{
 *   slug: string,
 *   title: string,
 *   desc: string,
 *   imgSrc: string,
 *   tag: string,
 *   tagModifier: string,
 *   href: string,
 * }>}
 */
export const HOME_DESIGN_SLIDER_ITEMS = codamDesignPortfolioItems
    .filter((item) => item.slug && item.image)
    .slice(0, HOME_DESIGN_SLIDER_LIMIT)
    .map((item, index) => ({
        slug: item.slug,
        title: item.title,
        desc: item.excerpt,
        imgSrc: item.image,
        tag: item.category ?? item.tags?.[0] ?? '코담디자인',
        tagModifier: TAG_MODIFIERS[index % TAG_MODIFIERS.length],
        href: codamDesignPortfolioItemHref(item),
    }))

export { CODAM_DESIGN_PORTFOLIO_PATH }
